<!--
 * @Author: 317473294@qq.com
 * @Date: 2023-09-10 11:07:13
 * @LastEditTime: 2023-10-21 15:36:23
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /english_admin_v1.1.0/src/components/menu/MenuTree.vue
-->
<template>
    <div>
      <template v-for="(menu,index) in menuData">
        <!-- 如果有children,则对该组件进行递归 -->
        <el-submenu  :key="index" :index="index + ''"  v-if="menu.children && menu.children.length>0">
            <template slot="title">
              <!-- 这里可以放置图标 -->
              <!-- <el-icon class="add"><Plus /></el-icon> -->
              <!-- <div :class="{'submenu':menu.isclass1,'submenu2':menu.isclass2}" @click="handleIcon(menu)"></div> -->
              <span slot="title">{{menu.name}}</span>
            </template>
             <!-- 这里对组件进行递归 传递的数据为子级menu.children-->
            <menu-tree :menuData="menu.children"></menu-tree>
        </el-submenu>
        <!-- 如果没有children，则不需要递归，直接显示 -->
        <el-menu-item :key="index" :index="index"  v-else>
            <template slot="title">
              <!-- <el-icon>
                <location />
              </el-icon> -->
              <span slot="title">{{menu.name}}</span>
            </template>
        </el-menu-item>
      </template>
    </div>
  </template>
  
  <script>
    export default {
     name:"menuTree",
     props:['menuData'],
    
    }
  </script>
<style scoped>
/* :deep(.el-sub-menu__icon-arrow){
  display: none;
} */
.add{
  display: flex;
  background-color: rgb(51, 102, 241);
  padding:5px;
  color: #fff;
  font-weight: bold;
}
:deep(.el-sub-menu::before){
  content: '+';
}
.submenu::before{
  content: "+";
  /* text-align: center; */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  padding: 3px;
  background-color: #5592f3;
  color: #fff;
  font-size: 16px;
  margin-right: 5px;
}
.submenu2::before{
  content: "-";
  /* text-align: center; */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  padding: 3px;
  background-color: #5592f3;
  color: #fff;
  font-size: 16px;
  margin-right: 5px;

}
</style>
 


// WEBPACK FOOTER //
// src/components/menu/MenuTree.vue